import ObjectSort from 'shared/models/object-sort';

import GatewayOverviewRecord from 'features/gateway/domain/models/gateway-overview-record';

export enum GatewaySortType {
  Name = 'Name',
  Type = 'Type',
}

export interface GatewaySort {
  isAscending: boolean;
  sortType: GatewaySortType;
}

export const toGatewaySort = (sort: ObjectSort<GatewayOverviewRecord> | undefined): GatewaySort | undefined => {
  if (!sort) {
    return undefined;
  }

  switch (sort.property) {
    case 'name':
      return { isAscending: sort.isAscending, sortType: GatewaySortType.Name };
    case 'type':
      return { isAscending: sort.isAscending, sortType: GatewaySortType.Type };
    default:
      throw new Error(`Unsupported gateway sort property: ${sort.property}`);
  }
};
